import { Image, Tooltip, OverlayTrigger } from 'react-bootstrap';
import { Placement } from 'react-bootstrap/esm/types';

import { useAppSelector } from 'hooks';
import { profileImgDefault } from 'assets';

interface IAvatarProps {
  size?: number;
  onClick?: () => any;
  imgUrl?: string;
  className?: string;
  overlay?: string;
  overlayPlacement?: Placement;
  hasOverlay?: boolean;
  dataTestId?: string;
  rounded?: boolean;
  isDefault?: boolean;
}

const Avatar = ({
  size = 30,
  onClick,
  imgUrl = '',
  className = '',
  overlay,
  overlayPlacement = 'auto',
  hasOverlay,
  dataTestId,
  rounded = true,
  isDefault = false
}: IAvatarProps) => {
  const displayName = useAppSelector((state) => state.oauth.data?.displayName);

  if (overlay || hasOverlay) {
    return (
      <OverlayTrigger
        placement={overlayPlacement}
        overlay={<Tooltip id="tooltip-avatar-overlay">{overlay || displayName}</Tooltip>}
      >
        <Image
          data-test={dataTestId}
          data-test-default={isDefault}
          src={imgUrl || profileImgDefault}
          roundedCircle={rounded}
          width={rounded ? size : undefined}
          height={size}
          onClick={onClick}
          className={`${onClick ? 'hoverable' : ''} ${className}`}
        />
      </OverlayTrigger>
    );
  }

  return (
    <Image
      data-test={dataTestId}
      data-test-default={isDefault}
      src={imgUrl || profileImgDefault}
      roundedCircle={rounded}
      width={rounded ? size : undefined}
      height={size}
      onClick={onClick}
      className={`${onClick ? 'hoverable' : ''} ${className}`}
    />
  );
};

export default Avatar;
